import { useLazyQuery } from '@apollo/client';
import { useMelwaysInfo } from '@seek/melways-react';
import {
  DEFAULT_SUGGESTION_COUNT,
  CompanyFilter,
  type Market,
} from '@ts-internal/shared-lib';

import { GetSuggestionsForCompanyDocument } from 'src/generated/graphql';

type Props = Omit<
  Parameters<typeof CompanyFilter>[0],
  'suggestions' | 'onDebouncedSearchTextChange' | 'onSearchTextChange'
> & {
  selectedMarket: Market;
};

export const CandidateCompanyFilter = ({ selectedMarket, ...props }: Props) => {
  const { language } = useMelwaysInfo();

  const [triggerGetSuggestions, { data }] = useLazyQuery(
    GetSuggestionsForCompanyDocument,
    {
      fetchPolicy: 'no-cache',
    },
  );

  const suggestions = (data?.ontologyOrganisations || []).map(
    ({ id, normalisedText }) => ({
      id,
      name: normalisedText,
    }),
  );

  const handleSearchTextChange = (newSearchText: string) => {
    if (newSearchText) {
      triggerGetSuggestions({
        variables: {
          query: newSearchText,
          count: DEFAULT_SUGGESTION_COUNT,
          countryCode2: selectedMarket,
          languageCode: language,
          session: '',
        },
      });
    }
  };

  return (
    <CompanyFilter
      {...props}
      suggestions={suggestions}
      onDebouncedSearchTextChange={handleSearchTextChange}
    />
  );
};
